"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeItemFromWishlistErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.removeItemFromWishlistErrors = [
    UseCaseError_1.UseCaseError.create('invalidData'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('problemInProcess')
];
//# sourceMappingURL=removeItemFromWishlistErrors.js.map